module.exports = __webpack_public_path__ + "static/media/领导人活动.20f2453c.svg";